module.exports = __webpack_public_path__ + "static/media/admin.118b016e.png";